module.exports = __webpack_public_path__ + "img/operationCapacity8.a33ee1f9.png";